module.exports = __webpack_public_path__ + "static/media/empire-logo.f09b42c7.png";